import { toast } from "sonner";
import { fmtErr } from "./api";

export const toastOk = (m) => toast.success(m);
export const toastInfo = (m) => toast.info(m);
export const toastWarn = (m) => toast.warning(m);

export function toastErr(e, retry) {
  const msg = typeof e === "string" ? e : fmtErr(e);
  return toast.error(msg, {
    duration: 8000,
    action: retry ? { label: "Retry", onClick: retry } : undefined,
  });
}
